import {
  APP_USER_DETAIL_ROUTE,
  APP_USER_MASTER_ROUTE,
  APP_USER_PERMISSION_HISTORY_ROUTE,
  APP_USER_PERMISSION_ROUTE,
} from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import { authorizationService } from "services/common-services/authorization-service";

import AppUserDetail from "./AppUserDetail/AppUserDetail";
import AppUserMaster from "./AppUserMaster/AppUserMaster";
import AppUserPermission from "./AppUserPermission/AppUserPermission";
import AppUserPermissionHistoryView from "./AppUserPermissionHistory/AppUserPermissionHistoryView";

function AppUserView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={APP_USER_MASTER_ROUTE}
        key={APP_USER_MASTER_ROUTE}
        component={AppUserMaster}
        auth={auth(APP_USER_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={APP_USER_DETAIL_ROUTE}
        key={APP_USER_DETAIL_ROUTE}
        component={AppUserDetail}
        auth={auth(APP_USER_DETAIL_ROUTE)}
      />
      <ProtectedRoute
        path={APP_USER_PERMISSION_ROUTE}
        key={APP_USER_PERMISSION_ROUTE}
        component={AppUserPermission}
        auth={auth(APP_USER_PERMISSION_ROUTE)}
      />
      <ProtectedRoute
        path={APP_USER_PERMISSION_HISTORY_ROUTE}
        key={APP_USER_PERMISSION_HISTORY_ROUTE}
        component={AppUserPermissionHistoryView}
        auth={auth(APP_USER_PERMISSION_HISTORY_ROUTE)}
      />
    </Switch>
  );
}

export { AppUserMaster, AppUserDetail };
export default AppUserView;
